<span *ngIf="descriptionParts.length == 0">{{description}}</span>
<span *ngIf="descriptionParts.length != 0">
  <span *ngFor="let part of descriptionParts"><span *ngIf="part.text" [innerHTML]="part.text"></span><a *ngIf="part.termid" routerLink="/term/{{part.termid}}">{{part.termid}}</a></span>
</span>

